import { signal } from "@preact/signals-react";

import ButtonAction from "componentsv2/button/ButtonAction";
import { openStatementViews } from "./viewOpenStatement";
import { closeStatementViews } from "./viewCloseStatement";
import { CurrencyCountIcon, SackDollarIcon } from "components/Icons";
import { useTable } from "storev2/tableStore";
import { genStoreId } from "componentsv2/tools/functions";
import { viewTips } from "./viewTips";
import ViewExpenses from "./ViewExpenses";

function Wizards() {
  const wizardOpen = {
    name: "account.statement.open",
    views: openStatementViews,
    size: "base",
  };
  const stepSignalsOpen = {
    nextMsg: signal(""),
    nextWidget: signal(null),
    nextButtons: signal([]),
  };

  const wizardClose = {
    name: "account.statement.close",
    views: closeStatementViews,
    size: "base",
  };

  const wizardTips = {
    name: "account.statement.tips",
    views: viewTips,
    size: "base",
  };

  const stepSignalsClose = {
    nextMsg: signal(""),
    nextWidget: signal(null),
    nextButtons: signal([]),
  };

  function onClose() {
    const { reload } = useTable.getState();
    const storeId = genStoreId("account.statement", null);
    reload(storeId);
  }

  return (
    <div className="grid grid-cols-1 2xl:grid-cols-2 rounded-lg gap-4 text-center items-center ">
      <ButtonAction
        key="account.statement.open"
        wizard={wizardOpen}
        icon={<CurrencyCountIcon className="fill-current text-blue-500 " />}
        stepSignals={stepSignalsOpen}
        openModal={signal(false)}
        onClose={onClose}
        size="full"
      />
      <ButtonAction
        key="account.statement.close"
        wizard={wizardClose}
        icon={<SackDollarIcon className=" fill-rose-950" />}
        stepSignals={stepSignalsClose}
        openModal={signal(false)}
        onClose={onClose}
        size="full"
      />

      <ButtonAction
        key="account.statement.tips"
        wizard={wizardTips}
        icon={<SackDollarIcon className="fill-current md:hidden xl:block" />}
        stepSignals={stepSignalsClose}
        openModal={signal(false)}
        onClose={onClose}
        size="full"
      />
      <ViewExpenses />
    </div>
  );
}

export default Wizards;
